export default {
  colors: {
    barelyGrey: "#F7F7F7",
    lightGrey: "#B7B7B7",
    grey: "#7F7F7F",
    darkGrey: "#4D4D4D",
    yellow: "#FFC400",
    darkYellow: "#FDBA12",
    red: "#FF0202",
  },
  fontFamily: "brandon",
  sizes: {
    medium: "48em",
  },
};
